/**
 * reimplementation of react-loader
 *
 */
import React, { useEffect, useRef } from 'react'

import PropTypes from 'prop-types'
import { Spinner } from 'spin.js'

import 'spin.js/spin.css'

const Loader = ({
  children,
  loaded,
  component,

  loadedClassName,
  parentClassName,
  ...options
}) => {
  const elRef = useRef(null)
  const spinnerRef = useRef(null)

  useEffect(() => {
    if (loaded) {
      delete spinnerRef.current
    } else if (elRef.current !== null) {
      spinnerRef.current = new Spinner(options)
      elRef.current.innerHTML = ''
      spinnerRef.current.spin(elRef.current)
    }
  }, [loaded])

  const r = React.createElement(
    component,
    {
      className: loaded ? loadedClassName : parentClassName,
      key: loaded ? 'content' : 'loader',
      ref: elRef
    },
    loaded ? children : undefined
  )

  return r
}

Loader.defaultProps = {
  component: 'div',
  loadedClassName: 'loadedContent',
  parentClassName: 'loader',
  loaded: false
}

Loader.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  fadeColor: PropTypes.string,
  component: PropTypes.any,
  corners: PropTypes.number,
  direction: PropTypes.oneOf([1, -1]),

  left: PropTypes.string,
  length: PropTypes.number,
  lines: PropTypes.number,
  loaded: PropTypes.bool,
  loadedClassName: PropTypes.string,

  options: PropTypes.object,
  parentClassName: PropTypes.string,
  position: PropTypes.string,
  radius: PropTypes.number,
  rotate: PropTypes.number,
  scale: PropTypes.number,
  shadow: PropTypes.bool,
  speed: PropTypes.number,
  top: PropTypes.string,

  width: PropTypes.number,
  zIndex: PropTypes.number,
  //
  children: PropTypes.node
}

export default Loader
